export default "__VITE_ASSET__CdvuTT7O__"